import FacebookIcon from 'assets/icons/landing/facebook'
import InstaIcon from 'assets/icons/landing/insta'
import PhoneIcon from 'assets/icons/landing/phone'
import TiktokIcon from 'assets/icons/landing/tiktok'
import WhatsappIcon from 'assets/icons/landing/wa'
import Container from 'components/UI/Landing/container'
import { useTranslation } from 'react-i18next'

export default function Contacts(): JSX.Element {
  const { t } = useTranslation('common')
  return (
    <div className='py-7 border-y border-grey-middle'>
      <Container>
        <div className='flex items-center justify-between'>
          <div className='w-full flex items-center justify-between sm:justify-start gap-5'>
            <a
              href='https://whatsapp.com/'
              target='_blank'
              className='flex items-center gap-2 text-muted'
              rel='noreferrer'
            >
              <span className='p-3 bg-secondary text-grey-dark dark:text-grey-dark-light rounded-full'>
                <WhatsappIcon />
              </span>
              <span className='text-xs sm:text-sm'>
                +7 776 159 5595 <br /> WhatsApp
              </span>
            </a>
            <a href='tel:595' className='flex items-center gap-2 text-muted' rel='noreferrer'>
              <span className='p-3 bg-secondary text-grey-dark dark:text-grey-dark-light rounded-full'>
                <PhoneIcon />
              </span>
              <span className='text-xs sm:text-sm'>
                595 <br /> {t('free-call')}
              </span>
            </a>
          </div>
          <div className='hidden sm:flex gap-2 text-muted'>
            <a
              href='https://www.instagram.com/bankffin.kz/'
              target='_blank'
              className='p-3 bg-secondary text-grey-dark dark:text-grey-dark-light rounded-full'
              rel='noreferrer'
            >
              <InstaIcon />
            </a>
            <a
              href='https://www.facebook.com/bankffin.kz'
              target='_blank'
              className='p-3 bg-secondary text-grey-dark dark:text-grey-dark-light rounded-full'
              rel='noreferrer'
            >
              <FacebookIcon />
            </a>
            <a
              href='https://tiktok.com/'
              target='_blank'
              className='p-3 bg-secondary text-grey-dark dark:text-grey-dark-light rounded-full'
              rel='noreferrer'
            >
              <TiktokIcon />
            </a>
          </div>
        </div>
      </Container>
    </div>
  )
}
